import { render, staticRenderFns } from "./CasesSelectionModal.vue?vue&type=template&id=1c970fce&"
import script from "./CasesSelectionModal.vue?vue&type=script&lang=js&"
export * from "./CasesSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./CasesSelectionModal.vue?vue&type=style&index=0&id=1c970fce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports